import styled from 'styled-components';
import { useContext } from 'react';
import { useSelector } from 'react-redux';
// import imageHelper from '@utils/imageHelper';
import textHelper from '@utils/textHelper';
import { Context as IsMobileContext } from '../../../Context/IsMobileContext';
import { Spacings, mobile } from '../../../../styleConstants';
import EventCard from './EventCard';
import EventCardMobile from './EventCardMobile';

const gridRowGap = Spacings.SPACING_16B;

const EventsWrapper = styled.div`
  display: flex;
  overflow: visible;
  justify-content: space-between;
  height: ${({ $rows }) =>
    `${$rows * 244 + ($rows - 1) * parseInt(gridRowGap, 10)}px`};
  padding: ${Spacings.SPACING_0B} ${Spacings.SPACING_24B};
  @media only screen and (max-width: ${mobile.maxWidth}) {
    margin-top: ${Spacings.SPACING_5B};
    height: auto;
    display: block;
    padding: ${Spacings.SPACING_0B};
  }
`;

const EventsContainer = styled.div`
  flex: 0 0 calc(50% - 60px);
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: ${({ $rows }) => `repeat(${$rows}, 1fr)`};
  grid-row-gap: ${gridRowGap};
`;

const getEvenOdd = (array) => {
  let index = 0;
  return (Array.isArray(array) ? array : []).reduce(
    (accumulator, element) => {
      accumulator[index].push(element);
      index = 1 - index;
      return accumulator;
    },
    [[], []]
  );
};

const getEventsInfo = (summitEvent) => {
  // eslint-disable-next-line no-shadow
  const { events, workshops } = summitEvent;
  return `${events > 0 ? textHelper.pluralize(events, 'event') : ''}${
    events > 0 && workshops > 0 ? ' & ' : ''
  }${workshops > 0 ? textHelper.pluralize(workshops, 'workshop') : ''}`;
};

const Events = () => {
  const isMobileDevice = useContext(IsMobileContext);
  const summitEvents = useSelector(({ summit }) => summit.events || []);
  const eventsInfo = summitEvents.map((event) => {
    return {
      ...event,
      eventsInfo: getEventsInfo(event)
    };
  });
  const [evenEvents, oddEvents] = getEvenOdd(eventsInfo);
  const rows = Math.ceil(summitEvents.length / 2);
  return (
    <EventsWrapper $rows={rows}>
      {isMobileDevice ? (
        summitEvents.map((event) => (
          <EventCardMobile
            key={event.id}
            title={event.title}
            textColor={event.colors.textColor}
            bgColor={event.colors.bgColor}
            description={event.description}
          />
        ))
      ) : (
        <>
          <EventsContainer $rows={rows}>
            {evenEvents.map((event) => (
              <EventCard
                key={event.id}
                title={event.title}
                textColor={event.colors.textColor}
                bgColor={event.colors.bgColor}
                imageUrl={`${event.image?.url}`}
                eventsInfo={event.eventsInfo}
                description={event.description}
              />
            ))}
          </EventsContainer>
          <EventsContainer $rows={rows}>
            {oddEvents.map((event) => (
              <EventCard
                key={event.title}
                title={event.title}
                textColor={event.colors.textColor}
                bgColor={event.colors.bgColor}
                imageUrl={`${event.image?.url}`}
                eventsInfo={event.eventsInfo}
                description={event.description}
              />
            ))}
          </EventsContainer>
        </>
      )}
    </EventsWrapper>
  );
};

export default Events;
